import { COMPANY } from "../data/company";
import { LegalLayout } from "../components/LegalLayout";

export default function Livrare() {
  return (
    <LegalLayout
      title="Politica de livrare"
      subtitle="Livrăm în toată România prin curier rapid. Plătești cash la curier."
      lastUpdated="Februarie 2026"
    >
      <h2 className="font-heading text-xl font-bold text-slate-900">1. Zone de livrare</h2>
      <p>
        Livrăm produsele <strong>oriunde în România</strong>, prin firme de
        curierat partenere.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">2. Termen de livrare</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>24-48 ore lucrătoare</strong> pentru majoritatea
          localităților
        </li>
        <li>
          Comenzile plasate până la ora 14:00 sunt expediate în aceeași zi
          lucrătoare
        </li>
        <li>
          Pentru zone izolate sau rurale, termenul poate fi de până la 3-4 zile
          lucrătoare
        </li>
      </ul>

      <h2 className="font-heading text-xl font-bold text-slate-900">3. Costuri de livrare</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>Transport GRATUIT</strong> pentru toate pachetele XXL
        </li>
        <li>
          Pentru celelalte produse, taxa de transport se calculează în funcție
          de greutate și zonă și se comunică la confirmarea comenzii
        </li>
      </ul>

      <h2 className="font-heading text-xl font-bold text-slate-900">4. Modalități de plată</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>Cash la curier (ramburs)</strong> — plătești în momentul
          primirii coletului
        </li>
      </ul>

      <h2 className="font-heading text-xl font-bold text-slate-900">5. Recepția coletului</h2>
      <p>
        În momentul primirii coletului, te rugăm să verifici integritatea
        ambalajului și conformitatea produselor cu comanda. Dacă coletul prezintă
        deteriorări vizibile, ai dreptul să refuzi primirea sau să soliciți
        întocmirea unui proces-verbal cu reprezentantul firmei de curierat.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">6. Lipsa la livrare</h2>
      <p>
        Dacă nu ești prezent la adresa indicată în momentul livrării, curierul
        te va contacta telefonic. În cazul în care coletul se întoarce la noi din
        motive ce nu ne sunt imputabile (adresă greșită, lipsă răspuns la
        telefon), o nouă livrare poate implica costuri suplimentare.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">7. Contact și tracking</h2>
      <p>
        Pentru informații despre comanda ta, sună-ne la {COMPANY.phone} sau
        scrie-ne pe WhatsApp. Îți vom trimite codul AWB de tracking imediat ce
        coletul este preluat de curier.
      </p>
    </LegalLayout>
  );
}
